/* eslint-disable */

import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const TeamMember = ({ id, name, role }) => {
  return (
    <div className="flex flex-row bg-color-dark-background-secondary items-start gap-2 p-2 rounded-lg max-w-xs border border-color-border-primary">
      <div className="w-10 h-10 rounded-full border border-color-border-primary bg-color-raindrop-dot" />
      <div className="flex flex-col text-left">
        <div className="font-bold">{name}</div>
        <div className="text-sm text-color-dark-text-secondary">{role}</div>
      </div>
    </div>
  );
};

const BasicDragAndDrop = () => {
  const [teamMembers, setTeamMembers] = useState([
    {
      id: 1,
      name: "John Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
    {
      id: 2,
      name: "Jane Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
    {
      id: 3,
      name: "Jenny Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
  ]);

  return (
    <DragDropContext>
      <Droppable droppableId="team-members">
        {(provided) => {
          return (
            <div
              className="flex flex-col"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {teamMembers.map((teamMember, index) => {
                return (
                  <Draggable
                    key={teamMember.id}
                    draggableId={teamMember.id.toString()}
                    index={index}
                  >
                    {(provided) => {
                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <TeamMember
                            key={teamMember.id}
                            id={teamMember.id}
                            name={teamMember.name}
                            role={teamMember.role}
                          />
                        </div>
                      );
                    }}
                  </Draggable>
                );
              })}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};

const NimbusTeamsReview = () => {
  const [teamMembers, setTeamMembers] = useState([
    {
      id: 1,
      name: "John Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
    {
      id: 2,
      name: "John Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
    {
      id: 3,
      name: "John Doe",
      role: "Responsible for The Raindrop Company",
      column: "1",
    },
  ]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = [...teamMembers];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    items.map((t, index) => {
      t.id = index + 1;
      return t;
    });
    setTeamMembers(items);
  };
  return (
    <div className="flex flex-col justify-center text-center gap-2">
      <BasicDragAndDrop />
    </div>
  );
};

export default NimbusTeamsReview;
